import React from 'react';
import { isMobile } from 'react-device-detect';
import PropTypes from 'prop-types';

import Text from './Text';
import Textarea from './Textarea';
import Select from './Select';
import DatePicker from './DatePicker';
import Radio from './Radio';
import Checkbox from './Checkbox';

class renderField extends React.PureComponent {
  state = {
    searchboxPopup: false,
  };

  render() {
    const {
      input,
      label,
      type,
      meta: { touched, error },
      params,
      centered,
      placeholder,
      classes,
    } = this.props;

    let inputField = <input {...input} type={type} placeholder={placeholder} className={classes} />;

    switch (type) {
        case 'select':
            inputField = (
                <Select
                    {...input}
                    {...params}
                    openPopup={() => {
                        this.setState({ searchboxPopup: true });
                    }}
                    closePopup={() => {
                        this.setState({ searchboxPopup: false });
                    }}
                />
            );
            break;
        case 'date':
            inputField = <DatePicker {...input} {...params} />;
            break;
        case 'radiogroup':
            inputField = <Radio {...input} {...params} />;
            break;
        case 'checkboxgroup':
            inputField = <Checkbox {...input} {...params} />;
        case 'textarea':
            inputField = <textarea {...input} placeholder={placeholder} className={classes} />;
        default:
    }

    if (centered) {
      return (
        <div className="form-register_question justifycentre">
          {label ? <label className="justifycentre">{label}</label> : null}
          { inputField }
          {touched && error && <label className="error">{error}</label>}
        </div>
      );
    }

    return (
      <div className={(isMobile && this.props.params.searchable && this.state.searchboxPopup) ? 'form-register_field searchbox-popup' : 'form-register_field'}>
        {(isMobile && this.props.params.searchable && this.state.searchboxPopup) &&
          <button className="modal-close modal-close-btn" type="button" onClick={() => { this.setState({ searchboxPopup: false }); }}>
            Close <span className="close-icon" />
          </button>
        }
        {label ? <label>{label}</label> : null}
        <div className="form-register_input">
          { inputField }
          {touched && error && <label className="error">{error}</label>}
        </div>
      </div>
    );
  }
}

renderField.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  centered: PropTypes.bool,
  type: PropTypes.string.isRequired,
  meta: PropTypes.object.isRequired,
  params: PropTypes.object,
  placeholder: PropTypes.string,
};

renderField.defaultProps = {
  params: {},
  label: null,
  centered: false,
  placeholder: null,
};

export default renderField;
export { renderField, Text, Select };



// WEBPACK FOOTER //
// ./src/Components/Inputs/index.jsx